import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'pc-button',
  props: {
    position: null,
    bg: null,
    active: null,
    hover: null,
    width: null,
    height: null,
    top: null,
    left: null
  },
  setup: function setup(__props) {
    var props = __props;
    _useCssVars(function (_vm, _setup) {
      return {
        "a3ad7744": _setup.active,
        "570c0e38": _setup.hover
      };
    });
    var style = computed(function () {
      var _props$bg2;
      var w = typeof props.width === 'number' ? "".concat(props.width / 100, "rem") : props.width;
      var h = typeof props.height === 'number' ? "".concat(props.height / 100, "rem") : props.height;
      var top = typeof props.top === 'number' ? "".concat(props.top / 100, "rem") : props.top;
      var left = typeof props.left === 'number' ? "".concat(props.left / 100, "rem") : props.left;
      if (props.position === 'relative') {
        var _props$bg;
        return {
          position: props.position,
          width: w,
          height: h,
          top: isNil(top) ? 'auto' : top,
          left: isNil(left) ? 'auto' : left,
          backgroundImage: "url(".concat((_props$bg = props.bg) !== null && _props$bg !== void 0 ? _props$bg : '', ")")
        };
      }
      return {
        position: props.position,
        width: w,
        height: h,
        top: top,
        left: left,
        backgroundImage: "url(".concat((_props$bg2 = props.bg) !== null && _props$bg2 !== void 0 ? _props$bg2 : '', ")")
      };
    });
    var active = computed(function () {
      return props.active ? "url(".concat(props.active, ")") : '';
    });
    var hover = computed(function () {
      return props.hover ? "url(".concat(props.hover, ")") : '';
    });
    return {
      __sfc: true,
      props: props,
      style: style,
      active: active,
      hover: hover
    };
  }
});